import React from 'react';
import {
  FaExclamationTriangle,
  FaTwitch,
  FaSpotify,
  FaSignOutAlt,
  FaCrown,
  FaGift,
  FaUser,
} from 'react-icons/fa';
import { HOME_TEXTS } from './constants';
import '../../styles/Home.css';

/**
 * Navbar de la page d'accueil
 *
 * @component
 * @param {Object} props
 * @param {string} [props.authError]
 * @param {boolean} [props.isAuthenticated]
 * @param {boolean} [props.isAuthLoading]
 * @param {Function} [props.onLogout]
 * @param {boolean} [props.isPremium]
 * @param {boolean} [props.isTrial]
 * @param {boolean} [props.hasPremiumAccess]
 * @param {boolean} [props.eligibleForTrial]
 * @param {Function} [props.onGoToDashboard]
 * @returns {JSX.Element}
 */
export default function HomeNavbar({
  authError,
  isAuthenticated = false,
  isAuthLoading = false,
  onLogout,
  isPremium = false,
  isTrial = false,
  hasPremiumAccess = false,
  eligibleForTrial = false,
  onGoToDashboard,
}) {
  const showSessionDetails = isAuthenticated && !isAuthLoading;

  const accountStatusLabel = isPremium
    ? 'Premium'
    : isTrial || hasPremiumAccess
      ? 'Essai actif'
      : eligibleForTrial
        ? 'Gratuit'
        : 'Gratuit';

  const accountStatusVariant = isPremium
    ? 'premium'
    : isTrial || hasPremiumAccess
      ? 'trial'
      : 'free';

  const handleLogout = () => {
    if (!onLogout) return;
    try {
      onLogout();
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
    }
  };

  return (
    <nav className="home-navbar" aria-label="En-tête de la page d'accueil">
      <div className="navbar-content">
        <div className="navbar-brand">
          <div className="brand-icon">
            <FaTwitch className="brand-twitch" />
            <FaSpotify className="brand-spotify" />
          </div>
          <h2 className="brand-text">
            <span className="brand-main">StreamingBot</span>
            <span className="brand-sub">Dashboard</span>
          </h2>
        </div>

        <div className="navbar-right">
          {showSessionDetails && (
            <div
              className="home-navbar-session home-navbar-session--minimal"
              aria-label="Offre et déconnexion"
            >
              <span
                className={`account-status-badge account-status-badge--${accountStatusVariant} home-navbar-offer-badge`}
                title={accountStatusLabel}
              >
                {isPremium ? (
                  <FaCrown className="account-status-badge-icon" />
                ) : isTrial || hasPremiumAccess ? (
                  <FaGift className="account-status-badge-icon" />
                ) : (
                  <FaUser className="account-status-badge-icon" />
                )}
                <span>{accountStatusLabel}</span>
              </span>
              {onLogout && (
                <button
                  type="button"
                  className="logout-button home-navbar-logout"
                  onClick={handleLogout}
                  title={HOME_TEXTS.LOGOUT_TITLE}
                  aria-label={HOME_TEXTS.LOGOUT_TITLE}
                >
                  <FaSignOutAlt />
                  <span>{HOME_TEXTS.LOGOUT}</span>
                </button>
              )}
            </div>
          )}

          {isAuthenticated && onGoToDashboard && (
            <button
              type="button"
              className="navbar-link home-navbar-dashboard"
              onClick={onGoToDashboard}
              aria-label={HOME_TEXTS.APPS_SECTION.DASHBOARD_TITLE}
            >
              {HOME_TEXTS.NAV_DASHBOARD}
            </button>
          )}

          {(!isAuthenticated || !showSessionDetails) && (
            <div className="navbar-status">
              <span className="status-dot" />
              <span className="status-text">En ligne</span>
            </div>
          )}
        </div>
      </div>

      {authError && (
        <div className="navbar-error">
          <FaExclamationTriangle />
          <span>Erreur d&apos;authentification: {authError}</span>
        </div>
      )}
    </nav>
  );
}
